import VirtualTable from '../VirtualTable';
import { IVirtualizedTableListProps } from '../VirtualTable.types';

import styles from './VirtualizedTableList.module.scss';

function VirtualizedTableList<T extends object>(props: IVirtualizedTableListProps<T>): JSX.Element {
  /* eslint-disable react/jsx-props-no-spreading */
  return <VirtualTable className={styles.virtualTable} {...props} />;
}

export default VirtualizedTableList;
